const CSVTable = (props) => {
    const { data, transformFn = (row, index, arr) => row } = props;

    const parseRow = (str) => {
        return str.replace(/\"/g, '').split(',');
    };
    const dataArr = data.split('\n');
    const indexRow = parseRow(dataArr[0]);
    const dataRows = dataArr.slice(1);
    if (data === '') return null;
    return (
        <div id="table-wrap" tabIndex={0}>
            <table>
                <thead>
                    <tr>
                        {indexRow.map((field, f) => (
                            <th key={f} title={field} id={field} className={field.toLowerCase().replace(/ /g, '_')}>
                                {field}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {dataRows.slice(0).map((row, r) => {
                        let adjusted = transformFn(parseRow(row), r, dataRows);
                        return (
                            <tr key={r}>
                                {adjusted.map((val, v) => (
                                    <td key={v} header={indexRow[v]} title={val}>
                                        {val}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
export default CSVTable;
